/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * https://github.com/tldraw/tldraw/blob/d683cc09432197e89bddacf2b706b5eaad40e399/packages/tlschema/src/records/SWInstance.ts
 *
 * Changes:
 *  - Commented out everything but a couple methods
 *  - Disables some of the validators
 */ // import { BaseRecord, createRecordType, defineMigrations, RecordId } from '@supersig/store'
// import { JsonObject } from '@supersig/utils'
// import { T } from '@supersig/validate'
// import { Box2dModel, box2dModelValidator } from '../misc/geometry-types'
// import { idValidator } from '../misc/id-validator'
// import { cursorValidator, TLCursor } from '../misc/TLCursor'
// import { opacityValidator, TLOpacityType } from '../misc/TLOpacity'
// import { scribbleValidator, TLScribble } from '../misc/TLScribble'
// import { StyleProp } from '../styles/StyleProp'
// import { pageIdValidator, TLPageId } from './TLPage'
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { box2dModelValidator } from "../misc/geometry-types";
import { idValidator } from "../misc/id-validator";
/** @internal */ export const instanceIdValidator = idValidator("instance");
export function createInstanceRecordType(stylesById) {
    const stylesForNextShapeValidators = {};
    for (const [id, style] of stylesById){
        stylesForNextShapeValidators[id] = T.optional(style);
    }
    const instanceTypeValidator = T.model("instance", T.object({
        typeName: T.literal("instance"),
        id: idValidator("instance"),
        currentPageId: idValidator("page"),
        followingUserId: T.string.nullable(),
        brush: box2dModelValidator.nullable(),
        // opacityForNextShape: opacityValidator,
        opacityForNextShape: T.any,
        stylesForNextShape: T.object(stylesForNextShapeValidators),
        // cursor: cursorValidator,
        cursor: T.any,
        // scribbles: T.arrayOf(scribbleValidator),
        scribbles: T.arrayOf(T.any),
        isFocusMode: T.boolean,
        isDebugMode: T.boolean,
        isToolLocked: T.boolean,
        exportBackground: T.boolean,
        screenBounds: box2dModelValidator,
        zoomBrush: box2dModelValidator.nullable(),
        isPenMode: T.boolean,
        isGridMode: T.boolean,
        chatMessage: T.string,
        isChatting: T.boolean,
        highlightedUserIds: T.arrayOf(T.string),
        canMoveCamera: T.boolean,
        isFocused: T.boolean,
        devicePixelRatio: T.number,
        isCoarsePointer: T.boolean,
        isHoveringCanvas: T.boolean.nullable(),
        openMenus: T.arrayOf(T.string),
        isChangingStyle: T.boolean,
        isReadonly: T.boolean,
        meta: T.jsonValue,
        // What i've added
        selectedMenu: T.string.nullable(),
        isPreviewing: T.boolean,
        popoverMenu: T.any.nullable(),
        propertyEditingModal: T.any.nullable(),
        // Element menu sibling for positioning new elements
        elementSibling: T.object({
            type: T.literalEnum("before", "inside", "after"),
            id: idValidator("node")
        }).optional(),
        // previewingVariant: T.string.optional(),
        // websocket url, for remote sync
        wsUrl: T.string.optional(),
        // Preview
        preview: T.object({
            device: T.string,
            scale: T.number,
            orientation: T.literalEnum("portrait", "landscape")
        })
    }));
    return createRecordType("instance", {
        migrations: instanceMigrations,
        validator: instanceTypeValidator,
        scope: "session"
    }).withDefaultProperties(()=>({
            followingUserId: null,
            opacityForNextShape: 1,
            stylesForNextShape: {},
            brush: null,
            scribbles: [],
            cursor: {
                type: "default",
                rotation: 0
            },
            isFocusMode: false,
            exportBackground: false,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isDebugMode: process.env.NODE_ENV === "development",
            isToolLocked: false,
            screenBounds: {
                x: 0,
                y: 0,
                w: 1080,
                h: 720
            },
            zoomBrush: null,
            isGridMode: false,
            isPenMode: false,
            chatMessage: "",
            isChatting: false,
            highlightedUserIds: [],
            canMoveCamera: true,
            isFocused: false,
            devicePixelRatio: typeof window === "undefined" ? 1 : window.devicePixelRatio,
            isCoarsePointer: false,
            isHoveringCanvas: null,
            openMenus: [],
            isChangingStyle: false,
            isReadonly: false,
            wsUrl: undefined,
            // previewingVariant: undefined,
            // What I've added
            selectedMenu: null,
            isPreviewing: false,
            popoverMenu: null,
            propertyEditingModal: null,
            elementSibling: undefined,
            preview: {
                device: "phone",
                scale: 0.8,
                orientation: "portrait"
            },
            meta: {}
        }));
}
/** @internal */ export const instanceVersions = {
    AddTransparentExportBgs: 1,
    RemoveDialog: 2,
    AddToolLockMode: 3,
    RemoveExtraPropsForNextShape: 4,
    AddLabelColor: 5,
    AddFollowingUserId: 6,
    RemoveAlignJustify: 7,
    AddZoom: 8,
    AddVerticalAlign: 9,
    AddScribbleDelay: 10,
    RemoveUserId: 11,
    AddIsPenModeAndIsGridMode: 12,
    HoistOpacity: 13,
    AddChat: 14,
    AddHighlightedUserIds: 15,
    ReplacePropsForNextShapeWithStylesForNextShape: 16,
    AddMeta: 17,
    RemoveCursorColor: 18,
    AddLonelyProperties: 19,
    ReadOnlyReadonly: 20,
    AddHoveringCanvas: 21,
    AddScribbles: 22
};
/** @public */ export const instanceMigrations = defineMigrations({
    currentVersion: instanceVersions.AddScribbles,
    migrators: {
        [instanceVersions.AddTransparentExportBgs]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    exportBackground: true
                });
            },
            down: (_param)=>{
                var { exportBackground: _ } = _param, instance = _object_without_properties(_param, [
                    "exportBackground"
                ]);
                return instance;
            }
        },
        [instanceVersions.RemoveDialog]: {
            up: (_param)=>{
                var { dialog: _ } = _param, instance = _object_without_properties(_param, [
                    "dialog"
                ]);
                return instance;
            },
            down: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    dialog: null
                });
            }
        },
        [instanceVersions.AddToolLockMode]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    isToolLocked: false
                });
            },
            down: (_param)=>{
                var { isToolLocked: _ } = _param, instance = _object_without_properties(_param, [
                    "isToolLocked"
                ]);
                return instance;
            }
        },
        [instanceVersions.RemoveExtraPropsForNextShape]: {
            up: (_param)=>{
                var { propsForNextShape } = _param, instance = _object_without_properties(_param, [
                    "propsForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: Object.fromEntries(Object.entries(propsForNextShape).filter(([key])=>[
                            "color",
                            "labelColor",
                            "dash",
                            "fill",
                            "size",
                            "font",
                            "align",
                            "verticalAlign",
                            "icon",
                            "geo",
                            "arrowheadStart",
                            "arrowheadEnd",
                            "spline"
                        ].includes(key)))
                });
            },
            down: (instance)=>{
                // we can't restore these, so do nothing :/
                return instance;
            }
        },
        [instanceVersions.AddLabelColor]: {
            up: (_param)=>{
                var { propsForNextShape } = _param, instance = _object_without_properties(_param, [
                    "propsForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: _object_spread_props(_object_spread({}, propsForNextShape), {
                        labelColor: "black"
                    })
                });
            },
            down: (instance)=>{
                const _instance_propsForNextShape = instance.propsForNextShape, { labelColor: _ } = _instance_propsForNextShape, rest = _object_without_properties(_instance_propsForNextShape, [
                    "labelColor"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: _object_spread({}, rest)
                });
            }
        },
        [instanceVersions.AddFollowingUserId]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    followingUserId: null
                });
            },
            down: (_param)=>{
                var { followingUserId: _ } = _param, instance = _object_without_properties(_param, [
                    "followingUserId"
                ]);
                return instance;
            }
        },
        [instanceVersions.RemoveAlignJustify]: {
            up: (instance)=>{
                let newAlign = instance.propsForNextShape.align;
                if (newAlign === "justify") {
                    newAlign = "start";
                }
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: _object_spread_props(_object_spread({}, instance.propsForNextShape), {
                        align: newAlign
                    })
                });
            },
            down: (instance)=>{
                return _object_spread({}, instance);
            }
        },
        [instanceVersions.AddZoom]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    zoomBrush: null
                });
            },
            down: (_param)=>{
                var { zoomBrush: _ } = _param, instance = _object_without_properties(_param, [
                    "zoomBrush"
                ]);
                return instance;
            }
        },
        [instanceVersions.AddVerticalAlign]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: _object_spread_props(_object_spread({}, instance.propsForNextShape), {
                        verticalAlign: "middle"
                    })
                });
            },
            down: (instance)=>{
                const _instance_propsForNextShape = instance.propsForNextShape, { verticalAlign: _ } = _instance_propsForNextShape, propsForNextShape = _object_without_properties(_instance_propsForNextShape, [
                    "verticalAlign"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape
                });
            }
        },
        [instanceVersions.AddScribbleDelay]: {
            up: (instance)=>{
                if (instance.scribble !== null) {
                    return _object_spread_props(_object_spread({}, instance), {
                        scribble: _object_spread_props(_object_spread({}, instance.scribble), {
                            delay: 0
                        })
                    });
                }
                return _object_spread({}, instance);
            },
            down: (instance)=>{
                if (instance.scribble !== null) {
                    const _instance_scribble = instance.scribble, { delay: _delay } = _instance_scribble, rest = _object_without_properties(_instance_scribble, [
                        "delay"
                    ]);
                    return _object_spread_props(_object_spread({}, instance), {
                        scribble: rest
                    });
                }
                return _object_spread({}, instance);
            }
        },
        [instanceVersions.RemoveUserId]: {
            up: (_param)=>{
                var { userId: _ } = _param, instance = _object_without_properties(_param, [
                    "userId"
                ]);
                return instance;
            },
            down: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    userId: "user:none"
                });
            }
        },
        [instanceVersions.AddIsPenModeAndIsGridMode]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    isPenMode: false,
                    isGridMode: false
                });
            },
            down: (_param)=>{
                var { isPenMode: _, isGridMode: __ } = _param, instance = _object_without_properties(_param, [
                    "isPenMode",
                    "isGridMode"
                ]);
                return instance;
            }
        },
        [instanceVersions.HoistOpacity]: {
            up: (_param)=>{
                var { propsForNextShape: { opacity } } = _param, propsForNextShape = _object_without_properties(_param.propsForNextShape, [
                    "opacity"
                ]), instance = _object_without_properties(_param, [
                    "propsForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    opacityForNextShape: Number(opacity !== null && opacity !== void 0 ? opacity : "1"),
                    propsForNextShape
                });
            },
            down: (_param)=>{
                var { opacityForNextShape: opacity } = _param, instance = _object_without_properties(_param, [
                    "opacityForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: _object_spread_props(_object_spread({}, instance.propsForNextShape), {
                        opacity: opacity < 0.175 ? "0.1" : opacity < 0.375 ? "0.25" : opacity < 0.625 ? "0.5" : opacity < 0.875 ? "0.75" : "1"
                    })
                });
            }
        },
        [instanceVersions.AddChat]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    chatMessage: "",
                    isChatting: false
                });
            },
            down: (_param)=>{
                var { chatMessage: _, isChatting: __ } = _param, instance = _object_without_properties(_param, [
                    "chatMessage",
                    "isChatting"
                ]);
                return instance;
            }
        },
        [instanceVersions.AddHighlightedUserIds]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    highlightedUserIds: []
                });
            },
            down: (_param)=>{
                var { highlightedUserIds: _ } = _param, instance = _object_without_properties(_param, [
                    "highlightedUserIds"
                ]);
                return instance;
            }
        },
        [instanceVersions.ReplacePropsForNextShapeWithStylesForNextShape]: {
            up: (_param)=>{
                var { propsForNextShape: _ } = _param, instance = _object_without_properties(_param, [
                    "propsForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    stylesForNextShape: {}
                });
            },
            down: (_param)=>{
                var { stylesForNextShape: _ } = _param, instance = _object_without_properties(_param, [
                    "stylesForNextShape"
                ]);
                return _object_spread_props(_object_spread({}, instance), {
                    propsForNextShape: {
                        color: "black",
                        labelColor: "black",
                        dash: "draw",
                        fill: "none",
                        size: "m",
                        icon: "file",
                        font: "draw",
                        align: "middle",
                        verticalAlign: "middle",
                        geo: "rectangle",
                        arrowheadStart: "none",
                        arrowheadEnd: "arrow",
                        spline: "line"
                    }
                });
            }
        },
        [instanceVersions.AddMeta]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    meta: {}
                });
            },
            down: (_param)=>{
                var { meta: _ } = _param, record = _object_without_properties(_param, [
                    "meta"
                ]);
                return _object_spread({}, record);
            }
        },
        [instanceVersions.RemoveCursorColor]: {
            up: (record)=>{
                const _record_cursor = record.cursor, { color: _ } = _record_cursor, cursor = _object_without_properties(_record_cursor, [
                    "color"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    cursor
                });
            },
            down: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    cursor: _object_spread_props(_object_spread({}, record.cursor), {
                        color: "black"
                    })
                });
            }
        },
        [instanceVersions.AddLonelyProperties]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    canMoveCamera: true,
                    isFocused: false,
                    devicePixelRatio: 1,
                    isCoarsePointer: false,
                    openMenus: [],
                    isChangingStyle: false,
                    isReadOnly: false
                });
            },
            down: (_param)=>{
                var { canMoveCamera: _canMoveCamera, isFocused: _isFocused, devicePixelRatio: _devicePixelRatio, isCoarsePointer: _isCoarsePointer, openMenus: _openMenus, isChangingStyle: _isChangingStyle, isReadOnly: _isReadOnly } = _param, record = _object_without_properties(_param, [
                    "canMoveCamera",
                    "isFocused",
                    "devicePixelRatio",
                    "isCoarsePointer",
                    "openMenus",
                    "isChangingStyle",
                    "isReadOnly"
                ]);
                return _object_spread({}, record);
            }
        },
        [instanceVersions.ReadOnlyReadonly]: {
            up: (_param)=>{
                var { isReadOnly: _isReadOnly } = _param, record = _object_without_properties(_param, [
                    "isReadOnly"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    isReadonly: _isReadOnly
                });
            },
            down: (_param)=>{
                var { isReadonly: _isReadonly } = _param, record = _object_without_properties(_param, [
                    "isReadonly"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    isReadOnly: _isReadonly
                });
            }
        },
        [instanceVersions.AddHoveringCanvas]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    isHoveringCanvas: null
                });
            },
            down: (_param)=>{
                var { isHoveringCanvas: _ } = _param, record = _object_without_properties(_param, [
                    "isHoveringCanvas"
                ]);
                return _object_spread({}, record);
            }
        },
        [instanceVersions.AddScribbles]: {
            up: (_param)=>{
                var { scribble: _ } = _param, record = _object_without_properties(_param, [
                    "scribble"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    scribbles: []
                });
            },
            down: (_param)=>{
                var { scribbles: _ } = _param, record = _object_without_properties(_param, [
                    "scribbles"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    scribble: null
                });
            }
        }
    }
});
/** @public */ export const SWINSTANCE_ID = "instance:instance";
